<!------------------------------------------------------------------------------------------
--  This template is used for things like the maintenance and tasks lists for log entries --
--  it displays the checkbox and the "x".                                                 --
--  NOTE: this template HEAVILY DEPENDS on the css class definitions for its L&F          --
------------------------------------------------------------------------------------------->
<template>
  <!--Both "buttons"--> 
  <div class=hydroware-success-failure-buttons>
    <!---------------------------------------------------------------------------------------
    -- Success button (as I write, this displays a green background and white checkmark    -- 
    -- when chosen)  It displays the same checkmark with a gray background when not chosen)--                                                                       --
    ---------------------------------------------------------------------------------------->
    <el-button ref="successButton"
      class="hydroware-checkbox-button"
      @click=successClicked
      circle>
      <!-----------------------------------------------------------------
      -- VERY COOL Vue FEATURE BELOW.... the <i> tag always "uses" the --
      -- the "el-icon-circl-check" class ("class=...").                --
      -- AND the v-bind:class directive tells it whether to use the    --
      -- "hydroware-icon-success" class (the success background color) --
      -- OR the                                                        --
      -- "hydroware-icon-notChosen" class (the notChosen bg color)     --
      -- based on the value of the successValue variable               --
      ------------------------------------------------------------------>
      <i class="el-icon-circle-check"
        v-bind:class="{
          'hydroware-icon-success':(successValue), 
          'hydroware-icon-notChosen':(!successValue)
        }">
      </i>
    </el-button>
    <!---------------------------------------------------------------------------------------
    -- Fail button (as I write, this displays a red background and white checkmark         -- 
    -- when chosen.  It displays the same checkmark with a gray background when not chosen)--                                                                       --
    ---------------------------------------------------------------------------------------->
    <el-button ref="failureButton"
      class="hydroware-checkbox-button"
      @click=failureClicked
      circle>
      <!-----------------------------------------------------------------
      -- VERY COOL Vue FEATURE BELOW.... the <i> tag always "uses" the --
      -- the "el-icon-circl-check" class ("class=...").                --
      -- AND the v-bind:class directive tells it whether to use the    --
      -- "hydroware-icon-fail" class (the failure background color)    --
      -- OR the                                                        --
      -- "hydroware-icon-notChosen" class (the notChosen bg color)     --
      -- based on the value of the successValue variable               --
      ------------------------------------------------------------------>
      <i class="el-icon-circle-close"
        v-bind:class="{
          'hydroware-icon-fail':(failureValue), 
          'hydroware-icon-notChosen':(!failureValue)
        }">
      </i>
    </el-button>
  </div>
</template>
<script>
export default {
  //A Boolean value (or null) is used by this widget
  //  true  - success is chosen
  //  false - fail is chosen
  //  null  - neither success nor fail is chosen
  props: {
    value:Boolean
  },

  //watch for changes in the model and be sure the buttons are set
  //properly when it does change (this makes the binding from the 
  //model to this compenent work properly)
  watch: {
    value() {
      this.setButtons(this.value)
      this.$emit('input', this.value);
    }
  },

  //The variables below indicate whether each button is
  //chosen or not chosen (true means the button is chosen)
  data: function () {
    return {
      successValue: false,
      failureValue: false,
      valueToEmit: null
    }
  },
  //Initialize the success/failure variables when this widget is mounted
  mounted() {
    this.setButtons(this.value)
  },
  
  methods: {
    setButtons(val) {
      //SET THE VALUE OF THE BUTTONS  
      //A non-null values means either success or failure is chosen
      //Once the successValue and failureValue are set here they
      //control the way the buttons look
      if(val != null) {
        //true indicates that success is chosen
        if(val==true) {
          this.successValue=true
          this.failureValue=false
        }
        //false indicates that failure is chosen
        else {
          this.successValue=false
          this.failureValue=true
        }
      }
      //null means neither success nor failure is chosen
      else {
        this.successValue=false
        this.failureValue=false
      }
    },
    //The methods below are called upon when the buttons are clicked
    successClicked() {
      let context=this
      //toggle the value of successValue
        this.successValue=!this.successValue
      //if successValue has toggled to true then fail value MUST BE false 
        if(context.successValue) {           
          context.failureValue=false
        }
      //Broadcast the change that was made by the code above
        context.emitValue();
    },
    failureClicked() {
      let context = this
      //toggle the value of failureValue
        context.failureValue=!context.failureValue
      //if failureValue has toggled to true then success value MUST BE false 
        if(context.failureValue) {
          context.successValue=false
        }
      //Broadcast the change that was made by the code above
      context.emitValue();
    },
    //The function below broadcasts the change that is made because
    //one of the buttons was clicked
    emitValue() {
      let context = this
      //Set the value to be broadcast
      //When neither success nor failure is chosen broadcast null
      //When success is chosen broadcast true
      //When failure is chosen broadcast false
        var valueToEmit = null;
        if(context.successValue == true) {
          valueToEmit = true
        }
        if(context.failureValue == true) {
          valueToEmit = false
        }
      //Broadcasting the 'input' event will change the value of the model itself
      //It also indicates to the vue file that is using this widget that its
      //@input function should be called.
      //NOTE: 'input' is not normally used with buttons but MUST be used in order
      //to update the model.
        this.$emit('input', valueToEmit)
        this.$emit('change', valueToEmit)
    }
  }
}
</script> 


// WEBPACK FOOTER //
// hydroware-success-failure-buttons.vue?87947dee